import { useLocalization } from "@tm/localization"
import { ArticleActionIcon, ErpIconType } from "@tm/models"
import { useDefaultArticleItemState } from "../ContextProviderStates/DefaultArticleItemState"
import { IconAction } from "./IconAction"

export function DetailsButton() {
    const { translateText } = useLocalization()
    const handleClickDetails = useDefaultArticleItemState((x) => x.handleClickDetails)

    const details: ArticleActionIcon = {
        iconType: ErpIconType.Details,
        displayType: "ICON",
        sort: 1,
        icon: "details",
        handler: () => handleClickDetails(),
        tooltip: translateText(43),
    }

    return <IconAction key={details.iconType} action={details} />
}
